import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '@app/env-service';

import { Factory } from '../store/factory.model';

@Injectable({
  providedIn: 'root',
})
export class FactoryService {
  url :string = environment.url;

  private readonly _factory = new BehaviorSubject<Factory[]>([]);
  public factory$ = this._factory.asObservable();

  constructor(private http :HttpClient) {
    this.getRecords();
  }

  updateRecord(newRecord :Factory, id :number) :Observable<any> {
    return this.http.put(`${this.url}/factories/${id}`, newRecord).pipe(
      tap((data :any) => {
        if (data.record) {
          const records = this._factory.getValue();
          const idx = records.findIndex((row) => {
            return row.id == id;
          });
          records.splice(idx, 1, <Factory>data.record);
          this._factory.next([...records]);
        }
      }),
    );
  }

  createRecord(data :Factory) :Observable<any> {
    return this.http.post(`${this.url}/factories`, data).pipe(
      tap((data :any) => {
        if (data.record) {
          const factory :Factory = data.record as Factory;
          this._factory.next([factory, ...this._factory.getValue()]);
        }
      }),
    );
  }

  deleteRecord(id :number) :Observable<any> {
    return this.http.delete(`${this.url}/factories/${id}`).pipe(
      tap((data :any) => {
        const records = this._factory.getValue();
        const idx = records.findIndex((row) => {
          return row.id == id;
        });
        records.splice(idx, 1);
        this._factory.next([...records]);
      }),
    );
  }

  getRecords() {
    this.http.get(`${this.url}/factories`).subscribe((data :any) => {
      this._factory.next(<Factory[]>data.records);
    });
  }

  getRfqs(factoryId :number) :Observable<any> {
    return this.http.get(`${this.url}/factories/${factoryId}/rfqs`);
  }
  getInvetory() :Observable<any> {
    return this.http.get(`${this.url}/factories/rfqs`);
  }

  getById(id :number) {
    const factories = this._factory.getValue();
    const factory :any = factories.find((row) => row.id == id);

    return factory;
  }

  search(params :any) :Observable<any> {
    return this.http.get(`${this.url}/factories/search`, { params: params });
  }
}
